import React, { useState, useEffect } from 'react';
import './order.scss';
import useTable from '../../../../utilities/useTable';
import { connect } from 'react-redux';
import history from '../../../../../router/browserrouter';

export const NewOrder = ({
  orders,
  LoadOrders,
  PersistOrder,
  DeleteOrders,
}) => {
  useEffect(() => {
    LoadOrders(0);
    return () => { };
  }, []);
  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });
  const { TblContainer, TblHead, TblPagination, recordsAfterPagingAndSorting } =
    useTable(orders, null, filterFn);
  console.log(orders);
  return (
    <div className="order-section container" >
      <TblPagination />
      <div className="saved">
        <h4> <strong> Saved Items ({orders.length} Cart)</strong></h4>
        <h5 className="text-dark"> <strong>
          The item(s) listed below
        </strong>
        </h5>
      </div>
      <div className="card-order">
        {recordsAfterPagingAndSorting().map((order) => {
          return (
            <div key={order.Id} className="card">
              <div className="first-section">
                <span className="text text-black">{order.transactionReference}</span>
                <br />
                <div className="d-flex">
                  <div className="date-ordered pr-3">
                    <small className="text"> <strong>{order.dateCreated}</strong></small>
                  </div>
                  <div className="text text-black" style={{ position: "relative", left: "2rem" }}>

                    <b>{order.amountToPay}</b>
                    <span>
                     <i
                        style={{ color: 'red', cursor: 'pointer', position: "relative", left: "1rem" }}
                        onClick={() => DeleteOrders(order.transactionReference)}
                        className="far fa-trash-alt"
                      ></i>
                    </span>
                  </div>
                </div>
              </div>

              <button onClick={() => {
                PersistOrder(order.transactionReference)
                history.push('/checkout');
              }} className="btn btn-primary w-75 mt-4">View Cart</button>

            </div>
          );
        })}
      </div>
    </div>
  );
};

function mapStateToProps(state) {
  return {
    categories: state.productReducer.categories,
    products: state.salesReducer.products,
    orders: state.salesReducer.orders,
  };
}

const mapToDispatchToProps = (dispatch) => ({
  LoadOrders(payload) {
    dispatch({ type: 'LOAD_ORDERS', payload });
  },
  DeleteOrders(payload) {
    dispatch({ type: 'DELETE_ORDERS', payload });
  },
  PersistOrder(payload) {
    dispatch({ type: 'PERSIST_ORDER_ID', payload });
  },
});

export default connect(mapStateToProps, mapToDispatchToProps)(NewOrder);
